import { render, staticRenderFns } from "./actividad-unica-resp.vue?vue&type=template&id=719ed8cd&scoped=true&"
import script from "./actividad-unica-resp.vue?vue&type=script&lang=js&"
export * from "./actividad-unica-resp.vue?vue&type=script&lang=js&"
import style0 from "./actividad-unica-resp.vue?vue&type=style&index=0&id=719ed8cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ed8cd",
  null
  
)

export default component.exports